import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { StyleSheet, View } from './components/base_components';

import BreadcrumbPath from './components/breadcrumb_path';
import UploadList from './components/upload_list';
import UploadProgresss from './components/upload_progress';

import UserStore from './stores/user_store';
import MediaGrantStore from './stores/media_grant_store';

import MediaIngest from './lib/media_ingest';

const styles = StyleSheet.create({
  uploadScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
});

let g_retryForever = false;

export default function UploadScreen(props) {
  const navigate = useNavigate();
  const params = useParams();
  const org = UserStore.useOrg();
  const grant_name = params.grant_name ?? '';
  const path = '/' + (params['*'] ?? '');
  const grant = MediaGrantStore.useMediaGrant(org?.org_id, grant_name);
  const media_grant_id = grant?.media_grant_id;
  const [list, setList] = React.useState<any[]>([]);
  const [show_progress, setShowProgress] = React.useState(
    MediaIngest.isRunning()
  );
  const [retry_forever, setRetryForever] = React.useState(false);

  React.useEffect(() => {
    _setRetry(false);
  }, []);
  React.useEffect(() => {
    MediaGrantStore.fetch(org?.org_id);
  }, [org?.org_id]);
  function _setRetry(value) {
    // evil
    g_retryForever = value;
    setRetryForever(value);
  }
  function _onClose() {
    navigate(`/home/${grant?.grant_name}${path}`, { replace: true });
  }
  function _onUpload() {
    if (list?.length > 0) {
      const opts = { org_id: org?.org_id, media_grant_id, path, list };
      MediaIngest.ingest(opts, (_, can_retry) => {
        if (can_retry && g_retryForever) {
          setTimeout(_onUpload, 0);
        }
      });
      setShowProgress(true);
    }
  }
  return (
    <View style={styles.uploadScreen}>
      <BreadcrumbPath
        volumeName={grant?.grant_name}
        prefix={`/home/${grant?.grant_name}/`}
        path={path}
        extra='Upload'
      />
      {show_progress ? (
        <UploadProgresss
          retryForever={retry_forever}
          onRetryChange={_setRetry}
          onClose={_onClose}
          onRetry={_onUpload}
        />
      ) : (
        <UploadList
          path={path}
          uploadList={list}
          onChange={setList}
          onUpload={_onUpload}
        />
      )}
    </View>
  );
}
